<template>
  <div class="sunshine-port">
    <Crumbs :info="info" :title="navList[0]" />
    <div class="port-container">
      <div class="port-nav">
        <menu-com :navList="navList"></menu-com>
      </div>
      <div class="port-content">
        <h2>服务咨询</h2>
        <p>
          您可以通过以下方式获得相关资讯和服务支持：
          在贺州市跨境电商综合服务平台官网查询相关服务内容（www.kj-hz.com）
          拨打我公司服务热线18953261932.
        </p>
        <img src="../../../assets/images/other/ohter.jpg" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import menuCom from "./common/menuCom.vue";
import Crumbs from "./common/Crumbs.vue";
import { navList } from "../../../model/enter";
export default {
  components: {
    menuCom,
    Crumbs
  },
  data() {
    return {
      info: {},
      navList
    };
  },
  created() {
    const path = this.$route.fullPath;
    const index = navList.findIndex(item => item.path === path);
    if (index !== -1) {
      this.info = navList[index];
    }
  }
};
</script>

<style scoped>
.port-container {
  width: 1200px;
  height: 920px;
  margin: 0 auto;
  display: flex;
  padding: 34px 30px;
  border: 1px solid #d3d3d3;
  margin-top: 30px;
  margin-bottom: 186px;
}
.port-content {
  flex: 1;
}
.port-content h2 {
  height: 38px;
  font-size: 30px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  color: #34373b;
  line-height: 38px;
  display: block;
  margin-bottom: 34px;
}
.port-content p {
  text-indent: 2em;
  font-size: 18px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #000000;
  line-height: 34px;
  margin-bottom: 34px;
}
</style>



// WEBPACK FOOTER //
// src/components/children/Enter/Conduct.vue